import { render } from "./ActualizaCasaMasivo.vue?vue&type=template&id=3b8b5bc8&scoped=true"
import script from "./ActualizaCasaMasivo.vue?vue&type=script&lang=js"
export * from "./ActualizaCasaMasivo.vue?vue&type=script&lang=js"

import "./ActualizaCasaMasivo.vue?vue&type=style&index=0&id=3b8b5bc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8b5bc8"]])

export default __exports__